import type { FC } from 'react';
import type { AccountSectionKey } from './account.helpers';
import styles from './AccountNav.module.scss';

type NavItem = {
    key: AccountSectionKey;
    label: string;
};
type Props = {
    active: AccountSectionKey;
    onSelect: (key: AccountSectionKey) => void;
    onLogout: () => void;
    disabled?: boolean;
    isMobile: boolean;
    mobileMenuOpen: boolean;
};

const ITEMS: NavItem[] = [
    { key: 'wishlist', label: 'Избранное' },
    { key: 'myData', label: 'Мои данные' },
    { key: 'orders', label: 'Заказы' },
    { key: 'reviews', label: 'Мои отзывы' },
    { key: 'discounts', label: 'Мои скидки' },
    { key: 'bonuses', label: 'Бонусы' },
];

const AccountNav: FC<Props> = ({ active, onSelect, onLogout, disabled, isMobile, mobileMenuOpen }) => {
    return (
        <nav className={styles.nav + (isMobile && !mobileMenuOpen ? ` ${styles.navMobileHidden}` : '')} aria-label="Меню личного кабинета">
            <div className={styles.menu}>
                {ITEMS.map((it) => {
                    const isActive = it.key === active;
                    const onClick = () => {
                        if (disabled) return;
                        onSelect(it.key);
                    };
                    return (
                        <button
                            key={it.key}
                            type="button"
                            className={`${styles.item} ${isActive ? styles.active : ''}`}
                            onClick={onClick}
                            disabled={disabled}
                            aria-current={isActive ? 'page' : undefined}
                        >
                            {it.label}
                        </button>
                    );
                })}
            </div>
            <div className={styles.footer}>
                <button type="button" className={styles.logout} onClick={onLogout} disabled={disabled} aria-label="Выйти из аккаунта">
                    Выйти
                    <img className={styles.logoutImg} src="/icons/new/exit.svg" alt="" />
                </button>
            </div>
        </nav>
    );
};

export default AccountNav;
